import '../../App.scss';
import ScoreChart from "./scoreChart"

import { Chart as ChartJS, ArcElement, Tooltip, Legend, scales } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

function getReception(rev1, rev2, type) {
	var recList = [];

	var recs  = [];
	var recs1 = [];

	if (type === "positive") {
		recs1 = rev1.positivereceptiontags.split('\n');
	} else {
		recs1 = rev1.negativereceptiontags.split('\n');
	}
	for (let rec of recs1) {
		if (!recs.includes(rec) && rec.length > 5 && !rec.includes("*no significant"))
			recs.push(rec)
	}

	if (rev2) {
		var recs2 = [];
		if (type === "positive") {
			recs2 = rev2.positivereceptiontags.split('\n');
		} else {
			recs2 = rev2.negativereceptiontags.split('\n');
		}

		for (let rec of recs2) {
			if (!recs.includes(rec) && rec.length > 5 && !rec.includes("*no significant")) {
				if (!rec.includes("age03"))
					recs.push(rec)
			}
		}
	}
	if (recs.length === 0) {
		recList.push(<li key={0}>No significant diversity-related {type} reception.</li>)
	}

	for (let i = 0; i < recs.length; i++) {
		var rec = recs[i].substring(8);
		rec = rec.charAt(0).toUpperCase() + rec.slice(1);
		recList.push(<li key={i}>{rec}</li>)
	}

	return recList;
}

function getBias(biasTags) {
	var btMap = new Map([
		["A", "Ableism"],
		["B", "Fails Bechdel Test"],
		["C", "Colorism"],
		["D", "Fails DuVernay Test"],
		["E", "Ethnic impersonation"],
		["F", "Fetishization/sexualization of WOC"],
		["Q", "Queer impersonation"],
		["S", "Stereotyping of woman or minority character"],
		["T", "Tokenizing minority character"],
		["V", "Minority characters only further violence"],
		["W", "White only"],
		["Y", "Young"]
	  ]);

	var btList = [];
	if (biasTags == "None") {
		btList.push(<li key={0	}>No biases tagged</li>)
	} else {
		for (let i = 0; i < biasTags.length; i++) {
			var bt = biasTags[i]; 
			var contested = bt.includes("*");
			var btItem = btMap.get(bt[0]);
			if (contested) 
				btItem += "*";
			btList.push(<li key={i}>{btItem}</li>)
		}
	}
	return btList;
}

export default function BiasReception(props) {

	var btList = getBias(props.biasTags)

	var posRec = getReception(props.reviewer1, props.reviewer2, "positive");
	var negRec = getReception(props.reviewer1, props.reviewer2, "negative");

	var title = props.reviewer1.propertyNameOriginal;


	

    return (
		<div className='align-left section-header white flex-col gap-24'>
				<div className="flex-col">
					<h1>Bias and Reception</h1>
				</div>	

				<div className='flex-item align-top gap-24'>
					<div className='canvas'>
						<ScoreChart
							chartData={props.chartData}
							/>
					</div>
					<div className='flex-col'>
						<div>
							<h3>Bias present in {title}</h3>
							<ul className='flex-col indvtext-lists'>
								{btList}
							</ul>

						<br></br>

						<details> 
							<summary>Positive reception</summary>
							<ul className='flex-col indvtext-lists'>
								{posRec}
							</ul>
						</details>

						<br></br>

						<details> 
							<summary>Negative reception</summary>
							<ul className='flex-col indvtext-lists'>
								{negRec}
							</ul>
						</details>

						</div>
					</div>
				</div>
		</div>
    )

}